export default __webpack_public_path__ + "static/media/keyvisual-siegen.045c6a24.jpg";